if (!window.otxAiScriptsInitialized) {
  window.otxAiScriptsInitialized = true;
  document.addEventListener('DOMContentLoaded', function () {
    initFaqsAi();
    initGaleriaAi();
    initBundlesAi();
    initStickyAi();
    initTarjetaAi();
    initFondoGaleriaAi();
  });
}

function initFaqsAi() {
  document.querySelectorAll('[data-otx-faq]').forEach(function (item) {
    var boton = item.querySelector('[data-otx-faq-toggle]');
    if (!boton) return;
    boton.addEventListener('click', function () {
      var abierto = item.classList.contains('otx-faq-open');
      item.closest('.otx-ai-faqs-lista').querySelectorAll('.otx-ai-faq-item').forEach(function (otro) {
        otro.classList.remove('otx-faq-open');
      });
      if (!abierto) item.classList.add('otx-faq-open');
    });
  });
}

function initGaleriaAi() {
  var galeria = document.querySelector('[data-otx-ai-galeria]');
  if (!galeria) return;
  var track = galeria.querySelector('[data-otx-ai-slides]');
  var slides = galeria.querySelectorAll('[data-otx-ai-slide]');
  var dots = galeria.querySelectorAll('[data-otx-ai-dot]');
  if (!track || !slides.length) return;

  function activarDot(indice) {
    dots.forEach(function (dot, i) {
      dot.classList.toggle('otx-ai-dot-activa', i === indice);
    });
  }

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      var indice = parseInt(dot.getAttribute('data-index'), 10) || 0;
      var slide = slides[indice];
      if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    });
  });

  if (dots.length && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var indice = Array.prototype.indexOf.call(slides, entry.target);
          activarDot(indice);
        }
      });
    }, { root: track, threshold: 0.6 });
    slides.forEach(function (slide) { observer.observe(slide); });
  }
}

function initBundlesAi() {
  document.querySelectorAll('[data-otx-ai-bundles]').forEach(function (wrap) {
    var bundles = wrap.querySelectorAll('[data-otx-ai-bundle]');
    var precioEl = document.querySelector('[data-otx-ai-precio-total]');
    var precioAntesEl = document.querySelector('[data-otx-ai-precio-total-antes]');
    var cantidadInput = document.querySelector('[data-otx-ai-cantidad]');
    if (!bundles.length) return;

    function seleccionar(bundle) {
      bundles.forEach(function (b) { b.classList.remove('otx-bundle-sel'); });
      bundle.classList.add('otx-bundle-sel');
      var precio = bundle.getAttribute('data-precio');
      var precioAntes = bundle.getAttribute('data-precio-antes');
      var cantidad = bundle.getAttribute('data-cantidad') || '1';
      if (precioEl && precio) precioEl.textContent = precio;
      if (precioAntesEl) {
        if (precioAntes) {
          precioAntesEl.textContent = precioAntes;
          precioAntesEl.style.display = '';
        } else {
          precioAntesEl.style.display = 'none';
        }
      }
      if (cantidadInput) cantidadInput.value = cantidad;
    }

    bundles.forEach(function (bundle) {
      bundle.addEventListener('click', function () { seleccionar(bundle); });
    });
  });
}

// Devuelve el botón de compra que el cliente ve de verdad.
// En esta tienda el pago es contrarreembolso: la app (Releasit) oculta el
// botón nativo del tema y coloca el suyo dentro del mismo formulario. Por eso
// buscamos el primer botón del formulario que tenga caja real.
function otxAiBotonCompraVisible() {
  var form = document.querySelector('[data-otx-producto-form]');
  if (!form) return null;
  var candidatos = form.querySelectorAll('button, input[type="submit"], a[role="button"]');
  for (var i = 0; i < candidatos.length; i++) {
    var b = candidatos[i];
    var r = b.getBoundingClientRect();
    if (r.width > 0 && r.height > 0 && !b.disabled) return b;
  }
  return null;
}

// Lanza la compra desde la barra flotante.
function otxAiComprar() {
  var boton = otxAiBotonCompraVisible();
  if (boton) { boton.click(); return; }
  // Si aún no hay botón visible (app cargando), llevamos al usuario a la caja
  // de compra en lugar de no hacer nada.
  var form = document.querySelector('[data-otx-producto-form]');
  if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
}
window.otxAiComprar = otxAiComprar;

function initStickyAi() {
  var sticky = document.querySelector('[data-otx-ai-sticky]');
  if (!sticky) return;

  // Ancla de referencia: el formulario de compra completo.
  // NO sirve observar [data-otx-ai-buy-btn]: con el contrarreembolso activo ese
  // botón queda oculto a 0x0 px, y un elemento sin caja nunca cruza el umbral
  // del IntersectionObserver — la barra se quedaba escondida a cualquier scroll.
  var ancla = document.querySelector('[data-otx-producto-form]') ||
              document.querySelector('[data-otx-ai-buy-btn]');
  if (!ancla) return;

  // Se muestra en cuanto la caja de compra sale por arriba de la pantalla.
  function actualizar() {
    sticky.classList.toggle('otx-sticky-visible', ancla.getBoundingClientRect().bottom < 0);
  }

  // Vía principal: observador sobre el FORMULARIO, que siempre tiene tamaño.
  // (Observar el botón nativo era el fallo original: la app de contrarreembolso
  // lo deja a 0x0 y un elemento sin caja nunca dispara el observador.)
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function () { actualizar(); }, { threshold: 0 }).observe(ancla);
  }

  // Respaldo, y primer pintado.
  actualizar();
  window.addEventListener('scroll', actualizar, { passive: true });
  window.addEventListener('resize', actualizar, { passive: true });
  // La app de contrarreembolso inyecta su botón después de cargar la página:
  // recalculamos cuando cambie el tamaño del formulario.
  if ('ResizeObserver' in window) new ResizeObserver(actualizar).observe(ancla);
}

// ---------------------------------------------------------------------------
// Aviso "también puedes pagar con tarjeta"
//
// Solo hace una cosa: dejarlo pegado por arriba al botón de la app de contra
// reembolso, porque el aviso apunta a ese botón con un pico y tiene que estar
// justo encima para que se entienda. En el HTML ya sale ahí (la app engancha
// su botón al final del formulario); esto es el seguro por si la app cambia
// dónde lo inyecta.
//
// NO lleva ningún botón de pago propio, y es deliberado: la opción de tarjeta
// está DENTRO del formulario de la app, con su descuento. Un atajo al checkout
// de Shopify se saltaría ese descuento.
// ---------------------------------------------------------------------------
function initTarjetaAi() {
  var aviso = document.querySelector('[data-otx-ai-tarjeta]');
  if (!aviso) return;

  var form = document.querySelector('[data-otx-producto-form]');

  function botonCod() {
    // Buscamos dentro del formulario a propósito: la app pinta ADEMÁS un botón
    // flotante con el mismo id, y ese no es el que nos interesa.
    return form ? form.querySelector('[id^="rsi_buy_now"]') : null;
  }

  function recolocar() {
    var cod = botonCod();
    if (!cod || !cod.parentNode) return false;
    if (cod.previousElementSibling !== aviso) cod.parentNode.insertBefore(aviso, cod);
    return true;
  }

  if (recolocar()) return;

  // La app carga después de la página: reintentamos 10 s y lo dejamos.
  var intentos = 0;
  var reloj = setInterval(function () {
    intentos++;
    if (recolocar() || intentos > 40) clearInterval(reloj);
  }, 250);
}


// ---------------------------------------------------------------------------
// Fondo difuminado de la galeria
//
// Cada foto se pinta tambien detras de si misma, ampliada y desenfocada, para
// que las franjas laterales tomen sus colores en vez de quedar dos barras
// negras. Los carteles verticales se ven enteros (object-fit: contain) sin
// que el marco parezca roto.
//
// Vivia dentro de otx-ai-garantias.liquid, 12.000 px mas abajo en la pagina:
// si se quitaba o se movia esa seccion desde el editor, la galeria entera se
// rompia. Ahora viaja con la seccion que tiene la galeria.
// ---------------------------------------------------------------------------
function initFondoGaleriaAi() {
  function pintar() {
    document.querySelectorAll('.otx-ai-slide').forEach(function (slide) {
      var img = slide.querySelector('img');
      if (!img) return;
      var poner = function () {
        var u = img.currentSrc || img.src;
        if (u) slide.style.setProperty('--otx-fondo', 'url("' + u + '")');
      };
      poner();
      img.addEventListener('load', poner, { once: true });
    });
  }
  pintar();
  window.addEventListener('load', pintar);
}
